var map = {
	"./BusStopKiosk.jpg": "55b5",
	"./FloorPiano.jpg": "4cab",
	"./Grocery.jpg": "5ddf",
	"./IPDDirectory.jpg": "8a70",
	"./Kollapse.jpg": "db2a",
	"./LetterOpener.jpg": "509d",
	"./PigPushToy.jpg": "8a64",
	"./Shi.jpg": "ff48",
	"./T3.jpg": "4b84",
	"./Tetris.jpg": "605c",
	"./TwoSix.jpg": "b974",
	"./WateringCan.jpg": "0c7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8b7";